import { Card, Paper, Snackbar, styled } from "@mui/material";
import BaseModal from "../baseModal"
import { Alert, Box, Button, CardMedia, Typography } from "@mui/material";
import { save } from "../../services/stacks";
import { useState } from "react";
import './style.scss';

const StyledPaper = styled(Paper)(() => ({
    backgroundColor: 'transparent',
    marginBottom: '0.5rem',
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px'
}))


const NftLoadoutModal = ({ show, close, nftId, imageUrl, contractId }) => {
    const [openSnackBar, setOpenSnackBar] = useState(false)
    const [snackBarMsg, setSnackBarMsg] = useState({ msg: '', severity: '' })

    function closeSnackBar() {
        setOpenSnackBar(false)
    }

    async function confirmPfp() {
        const payload = {
            "type": "basic",
            "basic": {
                "contract": contractId,
                "id": nftId
            },
            "advanced": {
                "background": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "accent": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "mouth": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "shirt": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "accessory": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "top": {
                    "contract": "full.contract::address",
                    "id": 0
                }
            }
        }
        save({ fileName: 'loadout.json', content: JSON.stringify(payload) }, { encrypt: false })
            .then(({ success, result }) => {
                if (success) {
                    setSnackBarMsg({ msg: 'NFT Avatar Updated!', severity: 'success' })
                    setOpenSnackBar(true)
                } else {
                    setSnackBarMsg({ msg: 'Basic NFT Avatar Error!', severity: 'error' })
                    setOpenSnackBar(true)
                }
            })
            .catch(err => {
                setSnackBarMsg({ msg: 'Basic Error occured!', severity: 'error' })
                setOpenSnackBar(true)
                console.log(err)
            })

    }

    async function defaultPfp() {
        const payload = {
            "type": "default",
            "basic": {
                "contract": "full.contract::address",
                "id": 0
            },
            "advanced": {
                "background": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "accent": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "mouth": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "shirt": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "accessory": {
                    "contract": "full.contract::address",
                    "id": 0
                },
                "top": {
                    "contract": "full.contract::address",
                    "id": 0
                }
            }
        }
        save({ fileName: 'loadout.json', content: JSON.stringify(payload) }, { encrypt: false })
            .then(({ success, result }) => {
                if (success) {
                    setSnackBarMsg({ msg: 'NFT Avatar Defaulted!', severity: 'success' })
                    setOpenSnackBar(true)
                } else {
                    setSnackBarMsg({ msg: 'Default NFT Avatar Error!', severity: 'error' })
                    setOpenSnackBar(true)
                }
            })
            .catch(err => {
                setSnackBarMsg({ msg: 'Default Error occured!', severity: 'error' })
                setOpenSnackBar(true)
                console.log(err)
            })

    }


    return (
        <>
            <BaseModal show={show} handleClose={close} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' }, }} noValidate autoComplete="off">
                    <div id="gift-form-container">
                        <StyledPaper>
                            <Card sx={{ height: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0)', borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}>
                                <CardMedia component="img" alt="Sample Image" sx={{ height: '13rem', objectFit: 'cover' }} image={imageUrl} />
                                <Typography variant="body2" className="nft-card-text">#{nftId}</Typography>
                            </Card>
                        </StyledPaper>
                        <div id="nft-loadout-btns"> 
                            <Button id="nft-loadout-default-btn" className="cancelbutton" onClick={defaultPfp}>Default</Button>
                            <Button id="nft-loadout-confirm-btn" className="button" onClick={confirmPfp}>Use</Button>
                        </div>
                    </div>
                </Box>
            </BaseModal>
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={(closeSnackBar)}>
                <Alert onClose={closeSnackBar} severity={snackBarMsg.severity} sx={{ width: '100%' }}>
                    {snackBarMsg.msg}
                </Alert>
            </Snackbar>
        </>
    )
}

export default NftLoadoutModal;